class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    window.loadSwiper.then((swiper) => {
      this.swiperLib = swiper;
      this._initCarousel();
    });
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-video-control-button]")) return;

      const zoomButton = e.target.closest("[data-open-zoom]");

      if (zoomButton) {
        this._openZoomGallery(zoomButton);
      }
    });

    this.handleVariantChange = (e) => {
      const { variant } = e.detail;

      if (!variant?.featured_media) return;

      const mediaId = parseInt(variant.featured_media?.id);

      this.querySelectorAll("[data-media-id]").forEach((media) => {
        media.style.display =
          parseInt(media.dataset.mediaId) === mediaId ? null : "none";
      });

      this.gallerySwiper?.slideToLoop(0);
    };

    document.addEventListener("variant:changed", this.handleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.handleVariantChange);
  }

  _initCarousel() {
    const { Swiper } = this.swiperLib;

    const initSwiper = () => {
      if (this.gallerySwiper || !this._isMobile) return; // skip if not mobile

      let swiperParams = {
        slidesPerView: "auto",
        loop: false,
        speed: 400,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        spaceBetween: 4,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      };

      this.gallerySwiper = new Swiper(
        this.querySelector(`.${this._prefix}__media-container`),
        swiperParams,
      );

      this.gallerySwiper.on("click", (_, e) => {
        if (e.target.closest("[data-video-control-button]")) return;

        this._openZoomGallery(this.querySelector("a, button"));
      });

      // this.gallerySwiper.on("slideChange", () => {
      //   const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
      //     slide.classList.contains("swiper-slide-visible"),
      //   );
      //   this._selectVideo(visibleSlides);
      // });
    };

    const destroySwiper = () => {
      if (this.gallerySwiper) {
        this.gallerySwiper.destroy(true, true);
        this.gallerySwiper = null;
      }
    };

    const handleResize = () => {
      if (this._isMobile) {
        initSwiper();
      } else {
        destroySwiper();
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // initialize on load
  }

  _openZoomGallery(trigger) {
    const zoomGallery = this._zoomMarkup?.content.children[0];

    if (!zoomGallery) return;

    zoomGallery.dataset.preselectMediaIndex =
      this.gallerySwiper?.realIndex || trigger.dataset.openZoom || 0;

    const html = zoomGallery.outerHTML;
    (trigger || this).dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: { html, target: "zoom-modal" },
      }),
    );
  }

  // _selectVideo(els) {
  //   this.activeVideos.forEach((video) => video.pause());

  //   this.activeVideos = [];

  //   els.forEach((el) => {
  //     const video = el.querySelector("video");

  //     if (video) {
  //       this.activeVideos.push(video);
  //       video.play();
  //     }
  //   });
  // }

  get _zoomMarkup() {
    return this.querySelector("[data-zoom-markup]");
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
